import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { Domicilio } from '../../model/Domicilio';
import { CanjeAction, CanjeStatus } from './useCanjeStatus';
import { LoginData } from '../../model/LoginData';
import { get } from '../../rest/api';
import { URL_API_USER_RESIDENCE } from '../../constants/urls';
import { CustomerData } from '../../model/CustomerData';
import { Phone } from '../../model/Phone';
import { phoneMapping } from '../../rest/phoneMapping';

/** Obteción de domicilios y teléfonos actuales del cliente desde el backend. */
export function useCustomerData(
  setExistingAddresses: Dispatch<SetStateAction<Domicilio[] | undefined>>,
  setExistingPhones: Dispatch<SetStateAction<Phone[] | undefined>>,
  dispatchCanjeAction: Dispatch<CanjeAction>,
  loginData: LoginData | null,
  show: boolean,
  status: CanjeStatus
) {
  const processResponse = useMemo(
    () => (resp: CustomerData) => {
      /*Direcciones*/
      if (resp?.locations && Array.isArray(resp.locations) && resp.locations.length > 0) {
        setExistingAddresses(resp.locations);
      } else {
        setExistingAddresses([]);
      }
      /*Teléfonos*/
      if (resp.phones && Array.isArray(resp.phones) && resp.phones.length > 0) {
        const phones = resp.phones.filter((value) => value.telephone?.trim?.().length > 0).map((value) => phoneMapping(value));

        setExistingPhones(phones);
      } else {
        setExistingPhones([]);
      }

      dispatchCanjeAction(CanjeAction.RECIBIR_RESPUESTA_DIRECCIONES);
    },
    [setExistingAddresses, setExistingPhones, dispatchCanjeAction]
  );
  const handleError = useMemo(
    () => () => {
      setExistingAddresses([]);
      setExistingPhones([]);
      dispatchCanjeAction(CanjeAction.RECIBIR_RESPUESTA_DIRECCIONES);
    },
    [dispatchCanjeAction, setExistingAddresses, setExistingPhones]
  );

  useEffect(() => {
    if (show && status === CanjeStatus.CANJE_PRODUCTO) {
      dispatchCanjeAction(CanjeAction.CONTINUAR);
      get(URL_API_USER_RESIDENCE, processResponse, handleError, loginData);
    }
  }, [dispatchCanjeAction, loginData, show, processResponse, status, handleError]);
}
